import { useCallback, useState } from "react";
import { notify } from "@/shared/utils/notify";
import { popularProductsService } from "../../../shared/services";

export const usePopularProducts = () => {
  const [loading, setLoading] = useState(false);

  const addProduct = useCallback(async (productId: number, nextPosition: number) => {
    if (loading) return false;
    setLoading(true);
    try {
      await popularProductsService.create({
        product_id: Number(productId),
        position: Number(nextPosition),
      });
      notify.success("Producto agregado a populares");
      return true;
    } catch (err: any) {
      notify.error(err?.message || "Error al agregar producto");
      return false;
    } finally {
      setLoading(false);
    }
  }, [loading]);

  const removeProduct = useCallback(async (productId: number) => {
    if (loading) return false;
    setLoading(true);
    try {
      const res = await popularProductsService.find({
        query: { product_id: productId, $limit: 1 },
      });
      const items = (res as any)?.data ?? res ?? [];
      const record = Array.isArray(items) ? items[0] : items;
      if (!record?.id) {
        notify.error("No se encontró el producto en populares");
        return false;
      }
      await popularProductsService.remove(record.id);
      notify.success("Producto quitado de populares");
      return true;
    } catch (err: any) {
      notify.error(err?.message || "Error al quitar producto");
      return false;
    } finally {
      setLoading(false);
    }
  }, [loading]);

  const updatePositions = useCallback(async (updates: { id: number; position_more_sales: number }[]) => {
    if (loading) return false;
    setLoading(true);
    try {
      for (let i = 0; i < updates.length; i++) {
        const { id: productId, position_more_sales: position } = updates[i];
        const res = await popularProductsService.find({
          query: { product_id: productId, $limit: 1 },
        });
        const items = (res as any)?.data ?? res ?? [];
        const record = Array.isArray(items) ? items[0] : items;
        if (record?.id) {
          await popularProductsService.patch(record.id, { position });
        }
      }
      notify.success("Orden actualizado correctamente");
      return true;
    } catch (err: any) {
      notify.error(err?.message || "Error al actualizar orden");
      return false;
    } finally {
      setLoading(false);
    }
  }, [loading]);

  return {
    loading,
    addProduct,
    removeProduct,
    updatePositions,
  };
};
